module.exports = __webpack_public_path__ + "static/media/Choose signature type.d20dc2bd.webp";